import ReviewsTable from "components/Tables/Reviews/ReviewsTable";
import React from "react";

const Reviews = () => {
  return (
    <div className="ml-2">
      <ReviewsTable />
    </div>
  );
};

export default Reviews;
